export default "__VITE_ASSET__9JqHrTMC__"